/**
 * Skills Tab - Wraps SkillEditorUI to work inside GameMenu tab system.
 * Uses SkillEditorUI.renderInBounds() for full-tab rendering.
 */

import { MenuTabContent } from '../MenuTabContent';
import { Player } from '@client/entities/Player';
import { SkillEditorUI } from '../SkillEditorUI';
import type { MouseEvent } from '../components';

export class SkillsTabNew extends MenuTabContent {
  private editor: SkillEditorUI;

  constructor(player: Player) {
    super(player);
    this.editor = new SkillEditorUI(player, 800, 600);
  }

  onActivate(): void {
    this.editor.open();
  }

  update(deltaTime: number): void {
    this.editor.update(deltaTime);
  }

  measureSize(_ctx: CanvasRenderingContext2D): { width: number; height: number } {
    return { width: this.bounds.width || 800, height: this.bounds.height || 600 };
  }

  protected renderContent(ctx: CanvasRenderingContext2D): void {
    const { x, y, width, height } = this.bounds;
    if (width <= 0 || height <= 0) return;
    this.editor.renderInBounds(ctx, x, y, width, height);
  }

  handleMouseEvent(e: MouseEvent): boolean {
    if (e.type === 'down') {
      this.editor.handleMouseDown(e.x, e.y);
      return true;
    }
    if (e.type === 'move') {
      this.editor.handleMouseMove(e.x, e.y);
      return true;
    }
    if (e.type === 'up') {
      this.editor.handleMouseUp(e.x, e.y);
      return true;
    }
    if (e.type === 'wheel' && e.deltaY !== undefined) {
      this.editor.handleWheel(e.deltaY);
      return true;
    }
    return false;
  }
}
